// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"64ad7c9d","193":"07a1fcda","471":"39efa74f","705":"b434cb17","893":"d777b400"}[chunkId] + ".chunk.js";
};